<template>
  <div class="selector-overlay-item">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'selector-overlay-item',
  props: {
    val: {

    }
  }
}
</script>

<style lang="scss" scoped>

.selector-overlay-item {
  position: relative;

  > * {
    z-index: 1;
  }
}

</style>